import { Grid } from "@mui/material";
import { FormikTextField } from "@shared";

import { CaseNoteResponse, ClientDetailResponse } from "@/api";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import FormikTimePicker from "@/common/components/fields/formik/formik-time-picker/FormikTimePicker";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { useCaseNoteFromDocumentEdit } from "./hooks/useCaseNoteFromDocumentEdit";

interface Props {
  client: ClientDetailResponse;
  caseNote: CaseNoteResponse;
  onClose: () => void;
}

export function CaseNoteFromDocumentEditDialog({ client, caseNote, onClose }: Props) {
  const { t } = useTranslation();
  const { formik } = useCaseNoteFromDocumentEdit(client, caseNote, onClose);

  return (
    <FormDialog
      title={t("clients.client.caseNotes.editDialog.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.save")}
    >
      <Grid container rowSpacing={2} columnSpacing={2} sx={{ pt: 2 }}>
        <Grid size={6}>
          <FormikTextField formik={formik} fieldName="filename" label={t("clients.client.caseNotes.form.fileName")} />
        </Grid>
        <Grid size={3}>
          <FormikDatePicker
            formik={formik}
            fieldName="date"
            label={t("clients.client.caseNotes.form.date")}
            clearable
          />
        </Grid>
        <Grid size={3}>
          <FormikTimePicker formik={formik} fieldName="time" label={t("clients.client.caseNotes.form.time")} />
        </Grid>
      </Grid>
    </FormDialog>
  );
}
